export default __webpack_public_path__ + "static/media/c006-d.88607ebf.jpg";